import { createSlice } from '@reduxjs/toolkit';
import { 
    fetchDeliveryPartnerByShortName, 
    fetchDeliveryPartnersList, 
    fetchMenuNavigationList,
    createDeliveryPartner,
    deleteDeliveryPartner,
} from '../thunk/menuThunk';

const initialState = {
    menuList: [],
    menuListLoading: false,
    menuListError: null,
    deliveryPartnersList: [],
    deliveryPartnersLoading: false,
    deliveryPartnersError: null,
    selectedDeliveryPartner: null,
    selectedDeliveryPartnerLoading: false,
    selectedDeliveryPartnerError: null,
    createDeliveryPartnerLoading: false,
    createDeliveryPartnerError: null,
    deleteDeliveryPartnerLoading: false,
    deleteDeliveryPartnerError: null,
};

const menusSlice = createSlice({
    name: 'menus',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Menu Navigation List
            .addCase(fetchMenuNavigationList.pending, (state) => {
                state.menuListLoading = true;
                state.menuListError = null;
            })
            .addCase(fetchMenuNavigationList.fulfilled, (state, action) => {
                state.menuListLoading = false;
                state.menuList = action.payload.message || action.payload.data || [];
            })
            .addCase(fetchMenuNavigationList.rejected, (state, action) => {
                state.menuListLoading = false;
                state.menuListError = action.payload;
            })
            // Delivery Partners List
            .addCase(fetchDeliveryPartnersList.pending, (state) => {
                state.deliveryPartnersLoading = true;
                state.deliveryPartnersError = null;
            })
            .addCase(fetchDeliveryPartnersList.fulfilled, (state, action) => {
                state.deliveryPartnersLoading = false;
                state.deliveryPartnersList = action.payload.data;
            })
            .addCase(fetchDeliveryPartnersList.rejected, (state, action) => {
                state.deliveryPartnersLoading = false;
                state.deliveryPartnersError = action.payload;
            })
            // Selected Delivery Partner
            .addCase(fetchDeliveryPartnerByShortName.pending, (state) => {
                state.selectedDeliveryPartnerLoading = true;
                state.selectedDeliveryPartnerError = null;
            })
            .addCase(fetchDeliveryPartnerByShortName.fulfilled, (state, action) => {
                state.selectedDeliveryPartnerLoading = false;
                state.selectedDeliveryPartner = action.payload;
            })
            .addCase(fetchDeliveryPartnerByShortName.rejected, (state, action) => {
                state.selectedDeliveryPartnerLoading = false;
                state.selectedDeliveryPartnerError = action.payload;
            })
            // Create Delivery Partner
            .addCase(createDeliveryPartner.pending, (state) => {
                state.createDeliveryPartnerLoading = true;
                state.createDeliveryPartnerError = null;
            })
            .addCase(createDeliveryPartner.fulfilled, (state, action) => {
                state.createDeliveryPartnerLoading = false;
                // Add the new partner to the list if it exists
                if (action.payload.data) {
                    state.deliveryPartnersList = [...state.deliveryPartnersList, action.payload.data];
                }
            })
            .addCase(createDeliveryPartner.rejected, (state, action) => {
                state.createDeliveryPartnerLoading = false;
                state.createDeliveryPartnerError = action.payload;
            })
            
            // Delete Delivery Partner
            .addCase(deleteDeliveryPartner.pending, (state) => {
                state.deleteDeliveryPartnerLoading = true;
                state.deleteDeliveryPartnerError = null;
            })
            .addCase(deleteDeliveryPartner.fulfilled, (state, action) => {
                state.deleteDeliveryPartnerLoading = false;
                state.deleteDeliveryPartnerError = null;
            })
            .addCase(deleteDeliveryPartner.rejected, (state, action) => {
                state.deleteDeliveryPartnerLoading = false;
                state.deleteDeliveryPartnerError = action.payload;
            });
    },
});

export default menusSlice.reducer;